import styled from "@emotion/styled";
import { Box, IconButton, InputBase, Typography } from "@mui/material";
import React from "react";
import { searchIcon } from "../../../assets";
import { GamePreview } from "../../../components/GamePreview";

const FlexRow = styled(Box)({
  display: "flex",
  flexDirection: "row",
});
const FlexColumn = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

export const BorrowedInventory = ({ colors, theme, games, NftBoxProps }) => {
  return (
    <FlexColumn
      width="90%"
      height={"330px"}
      style={{
        alignItems: "flex-start",
        marginTop: "50px",
        justifyContent: "space-between",
      }}
    >
      <FlexRow
        sx={{
          width: "100%",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          variant="subtitle2"
          color={colors.black[500]}
          fontWeight={500}
        >
          Borrowed Inventory N/A
        </Typography>
        <Typography
          variant="subtitle2"
          color={colors.black[500]}
          fontWeight={500}
        >
          See all
        </Typography>
      </FlexRow>

      <Box
        backgroundColor={theme.palette.secondary.dark}
        borderRadius="6px"
        sx={{ border: "1px solid #F3F5F9", width: "100%" }}
      >
        <IconButton type="button" sx={{ p: 1 }}>
          <img src={searchIcon} alt="search" />
        </IconButton>
        <InputBase
          sx={{ ml: 2, flex: 1, fontSize: "14px" }}
          placeholder="Search By NFT Name"
        />
      </Box>

      <Box
        sx={{
          overflow: "hidden",
          height: "200px",
        }}
        {...NftBoxProps()}
      >
        {[...games, ...games, ...games].map((nft, index) => (
          <Box gridColumn="span 5" gridRow="span 3">
            <GamePreview
              key={index}
              collectionName={nft.collectionName}
              image={nft.image}
            />
          </Box>
        ))}
      </Box>
    </FlexColumn>
  );
};
